import AxiosInstance from '../../api/axiosInstance';
import {renderErrorPopup} from '../../api/api-popups';

// Public status-code echo service - swap for a different URL/status if you
// have your own test endpoint. Kept as a GET so no real quote payload is
// needed; the point is exercising the exact same failure path as a real
// saveQuote() 403 (renderErrorPopup + rethrow -> unhandled rejection ->
// fatal-error reporting/recovery popup), not resending real quote data.
const FORCED_FAILURE_TEST_URL = 'https://httpbin.org/status/403';

export const triggerTestSaveQuoteFailure = () => {
  return AxiosInstance.get(FORCED_FAILURE_TEST_URL)
    .catch((error) => {
      renderErrorPopup("Server " + error, "", null, false);
      throw error;
    });
};
